/**
 * Convert hex color to RGB string format
 * @param {string} hex - Hex color (e.g., "#F2EFEF")
 * @returns {string} RGB string (e.g., "242, 239, 239") or original hex if invalid
 */
export default (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (result) {
    return `${parseInt(result[1], 16)}, ${parseInt(
      // eslint-disable-line i18next/no-literal-string
      result[2],
      16,
    )}, ${parseInt(result[3], 16)}`;
  }
  return hex;
};
